/**
 * 大会成果相关API URL
 */
import { API_BASE_URL, API_VERSION, API_MODULES } from '../config';

const BASE_URL = `${API_BASE_URL}${API_MODULES.CMS_SVC}`;

const BASE_RES_URL = `${API_BASE_URL}${API_MODULES.RES_SVC}`;

const BASE_RECORD_URL = `${API_BASE_URL}${API_MODULES.RECORD_SVC}`;

const BASE_CHATGPT_URL = `${API_BASE_URL}${API_MODULES.CHATGPT_SVC}`;

export default {    
  //获取栏目 - 大会成果左侧菜单
  GET_SECTION_MENU: `${BASE_URL}/home/api${API_VERSION.V1}/section/tree/home/ceggrc-web-2025`,
  //获取内容 - 大会成果内容 
  GET_REPORTS_BY_SECTION: `${BASE_URL}/home/api${API_VERSION.V1}/article/list`,
  //下载文件 
  DOWNLOAD_FILE: `${BASE_RES_URL}/res${API_VERSION.V3}/download`,
  //首页 
  GET_HOME_PAGE: `${BASE_URL}/home/api${API_VERSION.V1}/display`,
  //发送记录 
  SEND_RECORD: `${BASE_RECORD_URL}/api${API_VERSION.V1}/record`,
  //获取文章详情  
  GET_ARTICLE_DETAIL: `${BASE_URL}/home/api${API_VERSION.V1}/articleInfo`,

  // 使用ChatGPT 
  POST_CHATGPT_API_KEY: `${BASE_CHATGPT_URL}//jtapi${API_VERSION.V1}/chat_completions`,

  // post cms-svc/home/api/v1/article/latest/home/ceggrc-web-2025
  POST_LATEST_ARTICLE: `${BASE_URL}/home/api${API_VERSION.V1}/article/latest/home/ceggrc-web-2025`,
}; 